import { connect } from "react-redux";

import AnswerAttribute from "components/answer/AnswerAttribute";

import {
  //  set,
  setNextSurveyAttr,
  setPrevSurveyAttr
} from "redux/modules/answer/answerAttribute";
import { setAttrResult } from "redux/modules/answer/answerResult";
import { startEffect, finishEffect } from "redux/modules/answer/answerHeader";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";
import axios from "axios";
import { setAuthErrorType } from "redux/modules/answer/answerLogin";
import { answerLoginURL } from "utils/formatter";
import { baseApiUrl } from "../../api";
import { pathRole } from "../../utils/formatter";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader,
  answerStart: state.answerStart,
  answerAttribute: state.answerAttribute,
  isEffecting: state.answerHeader.isEffecting,
  answerResult: state.answerResult,
  locale: state.answerResult.locale,
});

const base = baseApiUrl();
const role = pathRole();

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("authError")));
  },
  selectItem: (currentSurveyAttr, attrItem, surveyAttrCount) => {
    dispatch(setAttrResult(currentSurveyAttr, attrItem));
    dispatch(startEffect());

    // ボタンのエフェクトを待つ
    setTimeout(() => {
      if (currentSurveyAttr.order < surveyAttrCount) {
        // 次の属性をセット
        dispatch(setNextSurveyAttr());
      } else {
        history.push("/question_ready", ownProps);
      }

      dispatch(finishEffect());
    }, 300);
  },
  handlePrevBtn: order => {
    dispatch(startEffect());

    setTimeout(() => {
      if (order > 1) {
        dispatch(setPrevSurveyAttr());
      } else {
        ownProps.history.goBack();
      }

      dispatch(finishEffect());
    }, 300);
  },
  startTemporarySave: params => {
    return axios({
      method: 'post',
      url: `${base}/${role}/survey_temp_save`,
      data: params
    })
      .then(res => {
        if (res.invalidStatusError) {
          dispatch(setAuthErrorType("canNotAnswer"));
          history.push(answerLoginURL(), ownProps);
        }
        return res;
      })
      .catch(error => {
        dispatch(openErrorDialog(error));
        throw error;  // important for child .catch()
      });
  },
  confirmedTemporarySave: () => {
    window.location.reload();
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerAttribute);



// WEBPACK FOOTER //
// ./src/containers/answer/AnswerAttributeContainer.js